import React from "react";
import ProcessesDashboardImpl from "./ProcessesDashboardPage";
import ProcessesDocumentsImpl from "./ProcessesDocuments";
import ProcessesHistoryImpl from "./ProcessesHistoryPage";

export function ProcessesDashboard() {
  return <ProcessesDashboardImpl />;
}

export function ProcessesDocuments() {
  return <ProcessesDocumentsImpl />;
}

export function ProcessesHistory() {
  return <ProcessesHistoryImpl />;
}
